import { memo } from 'react';

import { CloseButton, Text } from '@/components/core';
import { DocsIcon } from '@/components/icons';
import {
  CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID,
  EXPORT_TO_MAKE_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID,
  EXPORT_TO_N8N_FUNCTION_ID,
  EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID,
  EXPORT_TO_WEBHOOK_FUNCTION_ID,
  EXPORT_TO_ZAPIER_FUNCTION_ID,
} from '@/constants';
import { useTour } from '@/hooks';
import { toActionId, useGetAction } from '@/hooks/api';

export type HowToGuideProps = {
  actionId?: string | null;
};

const IHowToGuide = ({ actionId }: HowToGuideProps) => {
  const { data: action } = useGetAction(toActionId(actionId));
  const { showHowToGuide, setShowHowToGuide } = useTour({ prefixes: [actionId] });

  let docsLink;
  switch (action?.functionId) {
    case EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/excel';
      break;
    case EXPORT_TO_ZAPIER_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/zapier/export';
      break;
    case EXPORT_TO_MAKE_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/make';
      break;
    case EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/powerautomate/export';
      break;
    case EXPORT_TO_N8N_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/n8n';
      break;
    case EXPORT_TO_WEBHOOK_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/webhook';
      break;
    case CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/powerautomate/trigger';
      break;
    case CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/zapier/trigger';
      break;
    case CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID:
      docsLink = 'https://docs.cradl.ai/integrations/email';
      break;
    default:
      docsLink = 'https://docs.cradl.ai/integrations';
  }

  if (!showHowToGuide) return null;

  return (
    <div className="sticky flex w-full flex-col rounded-lg border border-gray-200 shadow-md">
      <div className="gap-sm flex items-center rounded-t-lg border-b border-gray-200 bg-gray-50 px-2 py-1">
        <DocsIcon className="size-3" />
        <Text size="xs" className="font-semibold">
          How to guide
        </Text>

        <div className="grow" />

        <CloseButton onPress={() => setShowHowToGuide(false)} />
      </div>
      <div className="p-2">
        <Text size="xs">
          Learn how to integrate with {action?.name} in our{' '}
          <span onClick={() => window.open(docsLink, '_blank')} className="cursor-pointer font-semibold underline">
            guide
          </span>{' '}
        </Text>
      </div>
    </div>
  );
};

export const HowToGuide = memo(IHowToGuide) as typeof IHowToGuide;
